import { createFileRoute } from "@tanstack/react-router";
import Component from "./-components/component";
import { UsersListSchema } from "@/routes/(pharma)/_layout/settings/-components/types";
import { Loading } from "@/layouts/loading";
import { pharmacyClient } from "@/connect";
import getPharmacyID from "@/utils/pharmacy_code";

export const Route = createFileRoute("/(pharma)/_layout/settings/")({
  component: Component,
  loader: async () => {
    const pharmacyCode = getPharmacyID();
    if (!pharmacyCode) {
      throw new Error("Pharmacy code is missing");
    }

    try {
      const response = await pharmacyClient.getUsersInPharmacy({
        pharmacyCode: pharmacyCode,
      });

      // Map gRPC response to schema
      const users: UsersListSchema[] = response.users.map((user) => ({
        user_id: user.userId,
        username: user.username,
        full_name: user.fullName,
      }));

      return { users };
    } catch (error) {
      console.error("Loader error:", error);
      throw new Error("Failed to fetch users list");
    }
  },
  pendingComponent: () => <Loading />,
  pendingMinMs: 1000,
  pendingMs: 1,
});